import styled from "styled-components";

export const SupportItem = styled.div`
  padding: 12px 14px;
  border: 1px solid #e1e6ee;
  border-radius: 8px;
  background: #fbfcfe;

  & + & {
    margin-top: 10px;
  }
`;

export const SupportLabel = styled.div`
  color: #0c53bb;
  font-size: 13px;
  font-weight: 700;
`;

export const SupportExplanation = styled.p`
  margin: 6px 0 0;
  color: #344054;
  font-size: 13px;
  line-height: 20px;
`;

export const Quote = styled.blockquote`
  margin: 8px 0 0;
  padding: 6px 10px;
  border-left: 3px solid #8fb1df;
  color: #48566b;
  font-size: 13px;
  font-style: italic;
  line-height: 20px;
`;

export const QuotePage = styled.span`
  margin-left: 6px;
  color: #66758a;
  font-size: 12px;
  font-style: normal;
`;

export const BrowsePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const BrowseHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ShelfRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ShelfNote = styled.div`
  color: #66758a;
  font-size: 12px;
`;

export const ShelfSubheading = styled.div`
  color: #344054;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;

export const PartRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 4px;
`;
